// extracted by mini-css-extract-plugin
export default {"container":"Settings_container__3BJDW","addBtn":"Settings_addBtn__rjHIp","form":"Settings_form__SmPv3","inputGroup":"Settings_inputGroup__PmFUV"};